/*
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-13 10:00:39
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-08-08 15:36:17
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/applysSatusList.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const evaluationApplyStatus = [
  {
    id: null,
    name: '全部',
  },
  {
    id: 217,
    name: '申请待确认',
  },
  {
    id: 218,
    name: '已确认',
  },
  {
    id: 219,
    name: '申请驳回',
  },
  {
    id: 201,
    name: '待提交',
  },
  // {
  //   id: 205,
  //   name: '待评价机构确认',
  // },
  {
    id: 206,
    name: '资料初审',
  },
  {
    id: 214,
    name: '资料复审',
  },
  {
    id: 207,
    name: '审核驳回',
  },
  {
    id: 208,
    name: '待支付',
  },
  {
    id: 209,
    name: '支付中',
  },
  {
    id: 210,
    name: '支付失败',
  },
  {
    id: 211,
    name: '评价中',
  },
  {
    id: 212,
    name: '评价完成',
  },
  {
    id: 213,
    name: '订单关闭',
  },
  {
    id: 216,
    name: '评价终止',
  },
]
export default evaluationApplyStatus;